// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-ul4p","template":"template-RF5X","section":"section-PweI","icons":"icons-wHU2","icon":"icon-GTqs"};